import type { App, Directive } from "vue"
import { usePermission } from "@/composables"

/**
 * 按后端权限码控制元素显隐（跟 @PreAuthorize("@ss.hasPermi(...)") 同一套权限码
 * 字符串），用法同若依：v-has-permi="'system:tenentOrder:approve'"、
 * v-has-permi="['system:tenentOrder:approve', 'system:tenentOrder:cancel']"（数组
 * 内任一命中即可）。跟 v-permission（角色级）是两套不同粒度，按钮级权限用这个。
 */
export default function setupHasPermiDirective(app: App) {
    const { hasPermi } = usePermission()

    function updateElVisible(el: HTMLElement, code: string | string[]) {
        if (!code) {
            throw new Error(
                `need permission code: like v-has-permi="'system:xxx:xxx'", v-has-permi="['system:xxx:xxx']"`
            )
        }
        if (!hasPermi(code)) {
            el.parentElement?.removeChild(el)
        }
    }

    const hasPermiDirective: Directive<HTMLElement, string | string[]> = {
        mounted(el, binding) {
            updateElVisible(el, binding.value)
        },
        beforeUpdate(el, binding) {
            updateElVisible(el, binding.value)
        },
    }

    app.directive("has-permi", hasPermiDirective)
}
